import { showDialog } from '../reducers/app';
import { get_any_transmitter_id } from '../util/definitions';
import { setupEditPanelTransmitterDialog } from '../reducers/edit_panel_transmitter_dialog';
export function newPanelTransmitter() {
    return (dispatch, getState) => {
        const { definitions } = getState();
        let panel_group_id;
        for (const obj of Object.values(definitions.panel_groups.entities)) {
            panel_group_id = obj.id;
            break;
        }
        if (panel_group_id == undefined) {
            return;
        }
        const device_id = get_any_transmitter_id(definitions);
        if (device_id == null) {
            return;
        }
        dispatch(setupEditPanelTransmitterDialog({
            panel_device_id: null,
            device_id,
            panel_group_id,
            ord: 1
        }));
        dispatch(showDialog('edit-panel-transmitter'));
    };
}
